import { Table } from 'semantic-ui-react';
import React from 'react';
import { TableRowSpinnerProps } from '../../interfaces/TableRowSpinnerProps';
import './TableRowSpinner.less';
import POSAnimatedImage from '../POSAnimatedImage';

export const TableRowSpinner = (props: TableRowSpinnerProps) => {
  return (
    <Table.Row className="table-spinner">
      <Table.Cell colSpan={props.colSpan} textAlign="center">
        <POSAnimatedImage className="brand-logo" image="ExpertBlackDelay" />
      </Table.Cell>
    </Table.Row>
  );
};
